import { BaseModel } from '../core/abstractions/base.model';

export class StatisticsItemModel extends BaseModel {
    group: string;
    label: string;
    value: number;

    constructor(init?: Partial<StatisticsItemModel>) {
        super();
        Object.assign(this, init);
    }
}
